export const SET_RESTAURANT_SEARCH_FILTER = "SET_RESTAURANT_SEARCH_FILTER";